/* eslint-disable padding-line-between-statements */
/* eslint-disable no-param-reassign */
/* eslint-disable no-secrets/no-secrets */
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import React, { useCallback, useEffect } from 'react';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { ClausesComponentVM } from 'ent-components-platform-react';
import TWIAHoCoverageTermHelper from '../../utils/TWIAHoCoverageTermHelper';
import metadata from './CoverageData.metadata.json5';
import styles from './CoverageData.module.scss';

function CoverageData(props) {
    const { homeOwnersData} = props;
    const lobData = homeOwnersData;
    
    useEffect(() => {
        if (!_.isUndefined(homeOwnersData)) {
            getCoverages();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    const renderValueField = useCallback((rowData, rowIndex) => (
        <CurrencyField
            id={`creditAmount_${rowIndex}`}
            value={rowData.amount}
            readOnly
            hideLabel
        />
    ), []);

    const renderNameField = useCallback((rowData) => <span>{rowData.name}</span>, []);
    
    const removePremiumProperties = (o) => {
        const removeAmountProps = (i) => {
            delete i.amount;
            i.terms?.forEach(t => delete t.amount_TWIA);
        };
    
        Object.keys(o).forEach(prop => {
            if (o[prop]) {
                o[prop]?.forEach(removeAmountProps);
            }
        });
        
        return o;
    };
    
    const getCoverages = () => {
        TWIAHoCoverageTermHelper.transformAndHideNonVisibleCoverageTerms(lobData);
        const coverages = {
            'baseCoverages_TWIA': lobData?.baseCoverages_TWIA,
            'additionalCoverages_TWIA': lobData?.additionalCoverages_TWIA,
            'exclusions_TWIA': lobData?.exclusions_TWIA,
            'indirectLossCoverages_TWIA': lobData?.indirectLossCoverages_TWIA,
            'creditsAndSurchages_TWIA': lobData?.creditsAndSurchages_TWIA
        };
        
        removePremiumProperties(coverages);
    }
    
    
    const overrideProps = {
        '@field': {
            labelPosition: 'left',
        },
        baseCoveragesComponent: {
            value: _.get(lobData, 'baseCoverages_TWIA'),
            path: 'baseCoverages_TWIA',
            homeOwnersData,
            additionalFieldsPath: "additionalCoverages_TWIA",
            loadingClause: true,
            isComponentValid: true,
            showError: false,
            showAdditionalFieldError: false,
            isEditable: false,
            isResidentialSummary: true,
            labelPosition: false,
            showAmount: true,
            showCoverageNameAmount: false
        },
        additionalCoveragesComponent: {
            value: _.get(lobData, 'additionalCoverages_TWIA'),
            path: "additionalCoverages_TWIA",
            loadingClause: true,
            isComponentValid: true,
            showError: false,
            showAdditionalFieldError: false,
            isEditable: false,
            isResidentialSummary: true,
            labelPosition: true,
            showAmount: true,
            showCoverageNameAmount: false
        },
        exclusionConditionsComponent: {
            value: _.get(lobData, 'exclusions_TWIA'),
            path: "exclusions_TWIA",
            loadingClause: true,
            isComponentValid: true,
            showError: false,
            showAdditionalFieldError: false,
            isEditable: false,
            isResidentialSummary: true,
            labelPosition: true,
            showAmount: true,
            showCoverageNameAmount: false
        },
        indirectLossCovComponent: {
            value: _.get(lobData, 'indirectLossCoverages_TWIA'),
            path: "indirectLossCoverages_TWIA",
            loadingClause: true,
            isComponentValid: true,
            showError: false,
            showAdditionalFieldError: false,
            isEditable: false,
            isResidentialSummary: true,
            labelPosition: true,
            showAmount: true,
            showCoverageNameAmount: false
        },
        lineTitle: {
            className:
                _.get(lobData, 'baseCoveragesTotal_TWIA') !== undefined
                    ? styles.spansytleleft : styles.spansytle
        },
        additionalTitle: {
            className:
                _.get(lobData, 'additionalCoveragesTotal_TWIA') !== undefined
                    ? styles.spansytleleft : styles.spansytle
        },
        indirectLossTitle: {
            className:
                _.get(lobData, 'indirectLossCoveragesTotal_TWIA') !== undefined
                    ? styles.spansytleleft : styles.spansytle
        },
        creditTitle: {
            className:
                _.get(lobData, 'creditsAndSurchagesTotal_TWIA') !== undefined
                    ? styles.spansytleleft : styles.spansytle
        },
        exclusionTitle: {
            className:
                _.get(lobData, 'exclusionsTotal_TWIA') !== undefined
                    ? styles.spansytleleft : styles.spansytle
        },
        indirectLossCoveragesTitle: {
            visible: _.get(lobData, 'indirectLossCoverages_TWIA')?.length > 0
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            clausesComponentVM: ClausesComponentVM,
        },
        resolveCallbackMap: {
            renderCreditName: renderNameField,
            renderCreditValue: renderValueField
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={homeOwnersData}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

CoverageData.propTypes = {
    data: PropTypes.shape({}),
};

export default CoverageData;